import P from 'helpers/predicates'
import * as R from 'ramda'

export default [
  [P.matchDecimal(0), 'Input must be integer.']
]

